import { load } from 'piecesjs'

/**
 * Map custom element tag names to dynamic imports.
 * Vite code-splits each piece (and its CSS) into separate chunks.
 *
 * Usage in Liquid:
 *   <c-example>Hello</c-example>
 */
const PIECE_LOADERS = {
  'c-example': () => import('./c-example.js'),
  'c-intro': () => import('./c-intro.js'),
  'c-main': () => import('./c-main.js'),
  'c-mux-video': () => import('./c-mux-video.js'),
  'c-scrollanimation': () => import('./c-scrollanimation.js'),
  'c-email-signup': () => import('./c-email-signup.js'),
}

function hasPiece(tagName, root) {
  if (root.matches?.(tagName)) return true
  return Boolean(root.querySelector?.(tagName))
}

/**
 * Load and mount pieces present in the DOM.
 * @param {ParentNode} [context=document] - Scope for discovery (e.g. a re-rendered section)
 */
export function initPieces(context = document) {
  const root = context instanceof Document ? document.documentElement : context

  for (const [tagName, importPiece] of Object.entries(PIECE_LOADERS)) {
    if (!hasPiece(tagName, root)) continue

    const loadContext = context instanceof Document ? undefined : context
    load(tagName, importPiece, loadContext)
  }
}
